import React from "react";
import Button from "@/components/Button";
import { SettingIcon, FullScreenIcon, MenuIcon } from "@/icons";
import { useSidebar } from "@/contexts/SideBarContext";
import { useTranslation } from 'react-i18next';
import Settings from "./Settings";
import { User } from "@/database/userDatabaseService";
import ExtraTools from "./ExtraTools";
import { DisplayTypes } from "@/types";
import { AppDispatch } from "@/redux-store";
import { BackIcon } from "@/icons/BackIcon";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  bookId: number;
  contentInfo: string;
  displayType: DisplayTypes;
  dispatch: AppDispatch;
  canvas: any;
  user: User | undefined;
}

const Header: React.FC<HeaderProps> = ({
  bookId,
  contentInfo,
  displayType,
  dispatch,
  canvas,
  user,
}) => {
  const { openSidebar, closeSidebar } = useSidebar();
  const { t } = useTranslation('translation', { keyPrefix: 'footer' });
  const navigate = useNavigate();

  const openSettingPage = () => {
    if (user) {
      openSidebar(
        "settings",
        `${t("settings")}`,
        "right",
        <Settings user={user} closeSideBar={closeSidebar} dispatch={dispatch} />
      );
    }
  };

  const openExtraTools = () => {
    if (user) {
      openSidebar(
        "extraTools",
        `${t("tools")}`,
        "right",
        <ExtraTools closeSideBar={closeSidebar} />
      );
    }
  };

  const navigateBookDetail = () => {
    navigate(`/book-detail/${bookId}`);
  }
  return (
    <div className="sm-header">
      <div className="sm-header-logo"></div>
      <div className="sm-header-content">
        <Button className="margin-right-10 back-navigation-btn" onClick={navigateBookDetail}>
          <BackIcon className={undefined}></BackIcon>
        </Button>
        <span>{contentInfo}</span>
      </div>
      <div className="sm-header-buttons">
        <Button
          className="obro-light-gray-btn tools-header-btn"
          icon={<MenuIcon color={"#7E92A2"} />}
          onClick={openExtraTools}
        />
        <Button
          className="obro-light-gray-btn settings-header-btn"
          icon={<SettingIcon className={undefined} color={undefined} />}
          onClick={openSettingPage}
        />
        <Button
          className="obro-light-gray-btn fullscreen-header-btn"
          onClick={() => {
            canvas.expandCanvas(displayType);
          }}
          icon={<FullScreenIcon color={"#7E92A2"} className={undefined} />}
        />
      </div>
    </div>
  );
};

export default Header;
